import axios from 'axios'
import { ref } from 'vue'

export function useCalls({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteCall = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/calls/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteCall,
    }
}
